import React, { FC } from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';

import { ModalPromptContent, Modal } from 'Shared/components';

export const FormNavPrompt: FC<{ when: boolean }> = ({ when }) => {
  return (
    <NavigationPrompt when={when}>
      {({ onConfirm, onCancel }) => (
        <Modal showModal onClose={onCancel}>
          <ModalPromptContent
            confirmButtonText="Continue without saving"
            cancelButtonText="Back"
            onCancel={onCancel}
            onConfirm={onConfirm}
          >
            <h3>Save your changes?</h3>
            <p>
              You have unsaved changes on this page. Are you sure you want to
              leave?
            </p>
          </ModalPromptContent>
        </Modal>
      )}
    </NavigationPrompt>
  );
};
